import React from "react";
import InputField from "./InputField";
import { IAddress } from "../../../models/LeadData.model";



// Made title optional since consumers may not need a title prop
interface AddressSectionProps {
  title?: string;
  address: IAddress;
  statesData: {
    state: string;
    city: string[];
    districts: string[];
  }[];
  setAddress: (Addr: IAddress) => void;
}


const AddressSection: React.FC<AddressSectionProps> = ({
  title,
  address,
  setAddress,
  statesData,
}) => (
  <div className="mb-1">
    {/* Optionally render section title */}
    {title && (
      <h3 className="text-sm font-medium text-gray-700 mb-2">{title}</h3>
    )}
    <InputField
      label="Line 1"
      value={address.line1}
      setValue={(val) => setAddress({ ...address, line1: val })}
      placeholder="Enter Address Line 1"
    />
    <div className="flex flex-col gap-2 mb-2">
      <label htmlFor="state" className="block  font-medium text-gray-700">
        State
      </label>
      <select
        value={address.state?.toLowerCase() || ""}
        onChange={(e) =>
          setAddress({
            ...address,
            state: e.target.value,
            city: "",
            district: "",
          })
        }
        className="w-full p-2 border rounded-md"
      >
        <option value="">Select State</option>
        {statesData.map((s) => (
          <option key={s.state} value={s.state.toLowerCase()}>
            {s.state.capitalizeWords()}
          </option>
        ))}
      </select>
      <label htmlFor="state" className="block  font-medium text-gray-700">
        City
      </label>
      <select
        value={address.city?.toLowerCase() || ""}
        onChange={(e) =>
          setAddress({
            ...address,
            city: e.target.value,
            district: "",
          })
        }
        disabled={!address.state}
        className="w-full p-2 border rounded-md"
      >
        <option value="">Select City</option>
        {statesData
          .find((s) => s.state === address.state.toLowerCase())
          ?.city.map((city) => (
            <option key={city} value={city}>
              {city.capitalizeWords()}
            </option>
          ))}
      </select>
      <label htmlFor="state" className="block  font-medium text-gray-700">
        District
      </label>
      <select
        value={address.district?.toLowerCase() || ""}
        onChange={(e) =>
          setAddress({
            ...address,
            district: e.target.value,
            city: address.city,
          })
        }
        disabled={!address.state}
        className="w-full p-2 border rounded-md"
      >
        <option value="">Select District</option>
        {statesData
          .find((s) => s.state === address.state.toLowerCase())
          ?.districts.map((district) => (
            <option key={district} value={district}>
              {district.capitalizeWords()}
            </option>
          ))}
      </select>
    </div>
    <InputField
      label="Pincode"
      value={address.pincode}
      setValue={(val) => setAddress({ ...address, pincode: val })}
      placeholder="Enter Pincode"
    />
  </div>
);

export default AddressSection;
